<!--Loading-->
<div id="loadingModal">
  <div>
    <img src="./assets/images/background/loading-fmarket-white.svg">
  </div>
</div>